import { combineReducers } from "redux"

// Front
// import Layout from "./layout/reducer"

// // Authentication
// import Login from "./auth/login/reducer"
// import Account from "./auth/register/reducer"
// import ForgetPassword from "./auth/forgetpwd/reducer"

import FilterReducer from "./Filter/reducer"
import ItemsReducer from "./Items/reducer"
import StoreReducer from "./Store/reducer"

const rootReducer = combineReducers({
  // Layout,
  // Login,
  // Account,
  // ForgetPassword,
  Filters :FilterReducer,
  Items :ItemsReducer,
  StoreHunter : StoreReducer
})

export default rootReducer
